import { ContainerDefinitionType, makeContainerDefinition } from '../definitions';
import { IDashboardVariationConfig } from './types';

export const TELADOC_DASHBOARD_CONFIG: IDashboardVariationConfig = {
    containers: [
        makeContainerDefinition({
            type: ContainerDefinitionType.UNASSIGNED,
            defaultEnabled: true,
        }),
    ],
};
